<script setup lang="ts">
import { ref } from 'vue'
import ChangelogContent from '@/components/releases/ChangelogContent.vue'
import { firstFormError } from '@/lib/forms'

withDefaults(defineProps<{
  errors: Partial<Record<'version' | 'changelog', string[]>>
  lockVersion?: boolean
}>(), {
  lockVersion: false,
})

const version = defineModel<string>('version', { required: true })
const changelog = defineModel<string>('changelog', { default: '' })

const tab = ref<'write' | 'preview'>('write')
const tabItems = [
  { label: 'Write', value: 'write', slot: 'write' as const },
  { label: 'Preview', value: 'preview', slot: 'preview' as const },
]
</script>

<template>
  <div class="flex flex-col gap-4">
    <UFormField
      label="Version"
      name="version"
      :description="lockVersion ? 'Set by the GitHub trusted publisher and cannot be changed here.' : 'Semantic version, e.g. 2.4.1.'"
      :error="firstFormError(errors.version)"
      :required="!lockVersion"
    >
      <UInput
        v-model="version"
        placeholder="2.4.1"
        icon="i-lucide-tag"
        class="w-full font-mono"
        :disabled="lockVersion"
      />
    </UFormField>

    <UFormField
      label="Changelog"
      name="changelog"
      hint="Markdown"
      :error="firstFormError(errors.changelog)"
    >
      <UTabs v-model="tab" :items="tabItems" size="sm" class="w-full">
        <template #write>
          <UTextarea
            v-model="changelog"
            :rows="10"
            class="w-full font-mono"
            placeholder="## What's new&#10;- ..."
          />
        </template>
        <template #preview>
          <div class="ring-default min-h-40 rounded-md p-3 ring">
            <ChangelogContent :markdown="changelog" empty-text="Nothing to preview." />
          </div>
        </template>
      </UTabs>
    </UFormField>
  </div>
</template>
